export default __webpack_public_path__ + "f130d246b84644757b85bebb412609b5.png";